/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterRef,
  PrinterRefOptional,
  PrinterRefMetaI,
  PrinterRefTrackedI,
} from "./printer-ref";
import { PrinterRefTracked, PrinterRefMeta } from "./printer-ref";

/**
 *
 * @export
 * @interface PrintOrderReceiptDTO
 */
export interface PrintOrderReceiptDTOOptional {
  /**
   *
   * @type {PrinterRef}
   * @memberof PrintOrderReceiptDTO
   */
  printerId?: PrinterRefOptional;
  /**
   *
   * @type {OrderRef}
   * @memberof PrintOrderReceiptDTO
   */
  orderId?: OrderRefOptional;
}

export interface PrintOrderReceiptDTO extends PrintOrderReceiptDTOOptional {
  /**
   *
   * @type {PrinterRef}
   * @memberof PrintOrderReceiptDTO
   */
  printerId: PrinterRef;
  /**
   *
   * @type {OrderRef}
   * @memberof PrintOrderReceiptDTO
   */
  orderId: OrderRef;
}

export interface PrintOrderReceiptDTOTrackedI {
  /**
   *
   * @type {PrinterRef}
   * @memberof PrintOrderReceiptDTO
   */
  printerId?: PrinterRefTrackedI;
  printerIdIsSet: boolean;
  /**
   *
   * @type {OrderRef}
   * @memberof PrintOrderReceiptDTO
   */
  orderId?: OrderRefTrackedI;
  orderIdIsSet: boolean;
}

transformDatesMap.set(
  "PrintOrderReceiptDTO",
  function (model: PrintOrderReceiptDTO) {
    const transformDatesprinterId = transformDatesMap.get("PrinterRef");
    if (transformDatesprinterId && model.printerId) {
      transformDatesprinterId(model.printerId);
    }
    const transformDatesorderId = transformDatesMap.get("OrderRef");
    if (transformDatesorderId && model.orderId) {
      transformDatesorderId(model.orderId);
    }
  },
);

export type PrintOrderReceiptDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerId: PropertyMeta<PrinterRefMetaI>;
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<OrderRefMetaI>;
}>;

export var PrintOrderReceiptDTOMeta: PrintOrderReceiptDTOMetaI =
  {} as PrintOrderReceiptDTOMetaI;
PrintOrderReceiptDTOMeta = typeMeta("PrintOrderReceiptDTO", {
  printerId: propertyMeta("printerId", false, true, false, PrinterRefMeta),
  orderId: propertyMeta("orderId", false, true, false, OrderRefMeta),
});

const metaI = PrintOrderReceiptDTOMeta;

registerMeta(() => {});

export class PrintOrderReceiptDTOTracked implements PrintOrderReceiptDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerId__I?: PrinterRefTracked = undefined;
  printerIdIsSet: boolean = false;
  set printerId(v: undefined | PrinterRefTracked) {
    if (v !== undefined) {
      this.printerId__I = v;
      this.printerIdIsSet = true;
    } else {
      this.printerId__I = v || undefined;
      this.printerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get printerId() {
    return this.printerId__I;
  }
  orderId__I?: OrderRefTracked = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | OrderRefTracked) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  constructor(config?: PrintOrderReceiptDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.printerId?.setIds();

    this.orderId?.setIds();
  }
  assignFrom(
    config: PrintOrderReceiptDTOOptional,
    options?: AssignOptions,
  ): PrintOrderReceiptDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.printerId && this.printerIdApplyFilter(optionsRequired.filter)) {
      this.printerId = new PrinterRefTracked(config.printerId, options);
      if (optionsRequired.unassign) this.printerIdIsSet = false;
      else this.printerIdIsSet = true;
    }
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = new OrderRefTracked(config.orderId, options);
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrintOrderReceiptDTOTrackedI {
    const cloned = {} as PrintOrderReceiptDTOTrackedI;
    if (
      this.printerIdIsSetDeep() &&
      this.printerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerIdIsSet = true;
      cloned.printerId = this.printerId?.removeUnset(filter);
    } else {
      //cloned.printerIdIsSet = false
    }
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId?.removeUnset(filter);
    } else {
      //cloned.orderIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrintOrderReceiptDTOTrackedI {
    if (!this.printerIdApplyFilter(filter)) this.printerIdIsSet = false;
    this.printerId?.unassignAll(filter);

    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;
    this.orderId?.unassignAll(filter);

    return this;
  }
  printerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrintOrderReceiptDTOMeta.printerId,
      PrintOrderReceiptDTOMeta,
      this.printerId,
      this,
    );
  }
  printerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerIdIsSet && this.printerIdApplyFilter(filter)) return true;
    return this.printerId?.anySet(filter) == true;

    return false;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrintOrderReceiptDTOMeta.orderId,
      PrintOrderReceiptDTOMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;
    return this.orderId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerIdIsSetDeep(filter)) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
